"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";

import { Error as ErrorCard } from "@/components/common/ErrorCard";

type Props = {
  error: Error & { digest?: string };
};

const Error = ({ error }: Props) => {
  useEffect(() => {
    // Log the error to Sentry
    Sentry.captureException(error);
  }, [error]);

  return <ErrorCard />;
};

export default Error;
